const INITIAL_STATE = {
  orders: [],
  ordersApi: [],
  lastVisible: null,
  hasMore: false,
  orderStatus: "",
  orderObj: null,
  trackingResult: null,
};

const setOrdersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_ALL_ORDERS":
      return { ...state, orders: [...action.payload] };
    case "GET_ALL_ORDERS":
      if (action.reset) {
        return {
          ...state,
          orders: [...action.payload.orders],
          lastVisible: action.payload.lastVisible,
          hasMore: action.payload.hasMore,
          orderStatus: action.orderStatus,
        };
      } else {
        return {
          ...state,
          orders: [...state.orders, ...action.payload.orders],
          lastVisible: action.payload.lastVisible,
          hasMore: action.payload.hasMore,
        };
      }

    case "GET_SINGLE_ORDER":
      return {
        ...state,
        orders: [action.payload, ...state.orders],
      };

    case "GET_SINGLE_ORDER_API":
      return { ...state, orderObj: action.payload };

    case "GET_ALL_ORDERS_API_OF_SINGLE_STATUS":
      return { ...state, ordersApi: [...action.payload] };

    case "UPDATE_MULTIPLE_ORDER_API":
      return {
        ...state,
        ordersApi: state.ordersApi.map((order) => {
          const updated = action.payload.find((o) => o.orderId === order.orderId);
          return updated ? { ...order, ...updated } : order;
        }),
      };

    case "UPDATE_1688_PAYMENT":
      return { ...state };

    case "UPDATE_1688_PAYMENT_LINK":
      return { ...state };

    case "UPDATE_ORDERS_WITH_PAYMENT_LINK":
      return { ...state };

    case "UPDATE_ORDER_API":
      return {
        ...state,
        ordersApi: state.ordersApi.map((order) =>
          order.orderId === action.payload?.orderId ? action.payload : order
        ),
      };

    case "DELETE_ORDER_API":
      return {
        ...state,
        ordersApi: state.ordersApi.filter(
          (order) => order.orderId !== action.payload?.orderId
        ),
      };

    case "GET_ORDER_TRACKING_RESULT":
      return { ...state, trackingResult: action.payload };

    case "UPDATE_ORDER":
      return {
        ...state,
        orders: state.orders.map((order) => {
          if (order.id == action.payload.id) {
            return action.payload;
          } else {
            return order;
          }
        }),
      };

    case "BULK_UPDATE_ORDER_STATUS":
      return {
        ...state,
        orders: state.orders.map((order) =>
          action.payload.ids.includes(order.id)
            ? { ...order, orderStatus: action.payload.orderStatus }
            : order
        ),
      };

    default:
      return { ...state };
  }
};
export default setOrdersReducer;
